import { IField } from "../../interfaces/field";

const DUMMY_RULE_TEMPLATE = `{%{0}|(user)React|(hash)1234%}`;

export class MacroHelper {

  static buildMacroRule(rule: string) {
    return DUMMY_RULE_TEMPLATE.replace('{0}', rule);
  }

  static setVisibilityMacro(field: IField, visibilityRule: string) {
    if (!field.properties) {
      field.properties = {};
    }
    if (!field.properties.visiblemacro) {
      field.properties.visiblemacro = {};
    }

    field.properties.visiblemacro['@ismacro'] = 'true';
    field.properties.visiblemacro['#text'] = this.buildMacroRule(visibilityRule);
  }

}